export default "__VITE_ASSET__CKwopQSi__"